<template>
  <div class="list">
    <navbar :docsName="docsName" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-2">
          <div class="container-fluid">
            <head-menu-filter
              :col="12"
              class="d-xl-flex"
              :headline="$t('global.filter')"
            ></head-menu-filter>
            <div class="row mb-2">
              <div
                class="viewfilter block br-t-l-0 br-t-r-0 w-100-p br-t-l-xl-0 br-t-r-xl-0 mt-minus-10"
              >
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <input
                        v-model="filters.bezeichnung"
                        class="form-control input"
                        type="text"
                        placeholder=" "
                      />
                      <label>{{ $t('global.designation') }}</label>
                    </div>
                  </div>
                </div>
                <filter-search-reset-button />
              </div>
            </div>
          </div>
        </div>
        <div class="col-10">
          <div class="container-fluid">
            <head-menu
              :col="12"
              class="d-xl-flex"
              :headline="navbarTitel"
              :gesamtanzahl="gesamtanzahl"
              :anzahl="anzahlDaten"
            ></head-menu>
            <div class="row mb-2">
              <div class="block br-t-l-0 w-100-p br-t-l-xl-0">
                <div class="row d-flex justify-content-between">
                  <div class="ml-4">
                    <router-link
                      class="btn btn-success"
                      :to="{
                        name: 'einstellungen-modul',
                        params: { anzeige: 0 },
                      }"
                    >
                      <font-awesome-icon icon="fa-regular fa-plus" />
                      {{ $t('global.new') }}
                    </router-link>
                  </div>
                  <div class="mr-4 float-right">
                    <button
                      class="btn btn-danger"
                      @click="oeffneLoeschenModal"
                    >
                      <font-awesome-icon
                        icon="fa-duotone fa-trash"
                        class="mr-2"
                      />
                      {{ $t('global.delete') }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="row block belegliste">
              <div class="w-100-p">
                <div>
                  <b-table
                    ref="selectableTable"
                    tbody-tr-class="item"
                    small
                    :items="listData"
                    :fields="fields"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    fixed
                    sort-icon-left
                    selectable
                    select-mode="range"
                    @row-dblclicked="details"
                    thead-tr-class="pointer"
                  >
                    <template v-slot:head(selected)="row">
                      <b-form-checkbox
                        v-model="row.selected"
                        @input="selectAllRows(row)"
                      ></b-form-checkbox>
                    </template>
                    <template v-slot:cell(selected)="row">
                      <b-form-checkbox
                        v-model="row.item.selected"
                        @input="onRowSelected(row)"
                      ></b-form-checkbox>
                    </template>
                    <template #cell(min_cp)="data">
                      <td
                        class="border-none"
                        v-if="data.item.dynamischeVergabe"
                      >
                        {{ data.item.min_cp }}
                      </td>
                    </template>
                    <template #cell(anzeigemodus)="data">
                      <td
                        class="border-none"
                        v-if="
                          data.item.noteneingabe_typ?.bezeichnung === 'Punkte'
                        "
                      >
                        {{ data.item.anzeigemodus?.bezeichnung }}
                      </td>
                    </template>
                  </b-table>

                  <infinite-loading
                    :identifier="infiniteId"
                    @infinite="(state) => infiniteHandler(state, 'app-api')"
                  >
                    <div slot="spinner">{{ $t('global.loadmoredata') }}</div>
                    <div slot="no-more">{{ $t('global.nofurtherdata') }}</div>
                    <div slot="no-results">
                      {{ $t('global.nofurtherdatafound') }}
                    </div>
                  </infinite-loading>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loeschen-modal
      id="module-loeschen-modal"
      :selectedIds="selectedIds"
      :multiple="true"
      @confirmed="modulLoeschen"
    />
  </div>
</template>

<script>
  import HeadMenu from '@/components/HeadMenu'
  import HeadMenuFilter from '@/components/HeadMenuFilter'
  import Navbar from '@/components/Navbar'
  import AppApi from '@/api/AppApi'
  import LoeschenModal from '@/components/Modals/LoeschenModal'
  import store from '@/store'
  import page from '@/mixins/Page'
  import filter from '@/mixins/Filter'
  import FilterSearchResetButton from '@/components/Buttons/FilterSearchResetButton'
  import InfiniteLoading from 'vue-infinite-loading'

  export default {
    name: 'ModuleListe',
    components: {
      Navbar,
      InfiniteLoading,
      HeadMenu,
      HeadMenuFilter,
      FilterSearchResetButton,
      LoeschenModal,
    },
    mixins: [page, filter],
    props: {
      id: {
        type: String,
        required: false,
        default: null,
      },
    },
    store,
    data() {
      return {
        filters: {
          bezeichnung: '',
        },

        sortBy: 'bezeichnung',
        sortDesc: false,
        selected: [],
        selectedIds: [],
      }
    },
    computed: {
      navbarTitel() {
        // ToDo: add global value
        return 'Module'
        // return this.$t("global.modul");
      },
      // ToDO: add global values for labels
      fields() {
        return [
          { key: 'selected', label: '' },
          {
            key: 'bezeichnung',
            sortable: true,
            label: this.$t('global.designation'),
            thStyle: { width: '30% !important' },
          },
          {
            key: 'noteneingabe_typ.bezeichnung',
            sortable: true,
            label: 'Noteneingabe Typ',
          },
          {
            key: 'anzeigemodus',
            sortable: true,
            label: 'Anzeigemodus',
          },
          {
            key: 'cp',
            sortable: true,
            label: 'CP',
          },
          {
            key: 'min_cp',
            sortable: true,
            label: 'Minimum CP',
          },
          {
            key: 'schwellenwert',
            sortable: true,
            label: 'Schwellenwert',
          },
        ]
      },
      queryParams: function () {
        var params = {}
        if (this.filters?.bezeichnung) {
          params.filterBezeichnung = this.setQueryParam(
            this.filters.bezeichnung
          )
        }
        return params
      },
    },
    watch: {},
    created() {
      // TODO: change to new API Path
      this.initFilter('liste-module', 'liste-modul/', true)
    },
    mounted() {
      this.$bus.$emit('searchWithFilter')
    },
    methods: {
      details(fach) {
        this.$router.push({
          name: 'einstellungen-modul',
          params: { id: fach.id, anzeige: 0 },
        })
      },
      modulLoeschen() {
        AppApi.delete('liste-modul/', { data: this.selectedIds })
          .then((response) => {
            this.selectedIds = []
            this.resetLoading(this)

            this.$notify({
              type: 'success',
              title: this.$t('global.actionsuccessful'),
              // TODO: add translation
              text: this.$t('global.moduledeletedsuccessfully'),
            })
          })
          .catch((e) => {
            this.$notify({
              type: 'warn',
              title: this.$t('global.actionfailed'),
              // TODO: add translation
              text: this.$t('global.modulecouldnotbedeleted'),
            })
          })
      },

      oeffneLoeschenModal() {
        if (this.selectedIds.length > 0)
          this.$bus.$emit('openLoeschenModal', 'module-loeschen-modal')
      },
    },
  }
</script>

<style></style>
